(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgm-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pgmCartReady) return;
    window.__pgmCartReady = true;

    var EN = (document.documentElement.lang || '').indexOf('en') === 0;
    function tr(it, en) { return EN ? en : it; }

    var lastFocus = null;
    var lastCart = null;

    function root() { return document.querySelector('[data-pgm-cart]'); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function shopRoot() {
      var r = root();
      return (r && r.dataset.root) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }
    /* "Titolo lungo \u2014 dettagli (ITA)" diventa "Titolo lungo" */
    function shortTitle(t) { return String(t || '').split(/\s+[\u2014\u2013]\s+/)[0]; }

    var MARK = '<svg class="pgm-cover__mark" viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" focusable="false"><circle cx="20" cy="20" r="17"/><path d="M20 9v11l7 4"/></svg>';

    function thumbHTML(item, r) {
      if (r.dataset.useImages === 'true' && item.image) {
        return '<img class="pgm-cart__img" src="' + esc(item.image) + '" alt="" loading="lazy">';
      }
      var title = esc(shortTitle(item.product_title));
      if (/planner/i.test(item.handle || '')) {
        return '<div class="pgm-cover pgm-cover--planner" aria-hidden="true"><div class="pgm-cover__in"><span class="pgm-cover__title">' + title + '</span><span class="pgm-cover__brand">Chronosmind</span>' + MARK + '</div></div>';
      }
      var author = r.dataset.author ? '<span class="pgm-cover__author">' + esc(r.dataset.author) + '</span>' : '';
      return '<div class="pgm-cover pgm-cover--ebook" aria-hidden="true"><div class="pgm-cover__in">' + author + '<span class="pgm-cover__title">' + title + '</span>' + MARK + '</div></div>';
    }

    function render(cart) {
      var r = root();
      if (!r) return;
      var body = r.querySelector('[data-pgm-cart-body]');
      var foot = r.querySelector('[data-pgm-cart-foot]');

      if (!cart.items.length) {
        body.innerHTML =
          '<div class="pgm-cart__empty"><h3>' + tr('Il carrello è vuoto', 'Your cart is empty') + '</h3><p>' + esc(r.dataset.emptyText) + '</p>' +
          '<a class="pgm-btn pgm-btn--action" href="' + esc(shopRoot()) + '#prodotti" data-pgm-cart-close>' + tr('Vedi i prodotti', 'See the products') + '</a></div>';
        foot.hidden = true;
        foot.innerHTML = '';
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var kind = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="pgm-cart__kind">' + esc(item.variant_title) + '</div>' : '';
        return '<div class="pgm-cart__item">' +
          '<div class="pgm-cart__thumb">' + thumbHTML(item, r) + '</div>' +
          '<div><div class="pgm-cart__name"><a href="' + esc(item.url) + '">' + esc(shortTitle(item.product_title)) + '</a></div>' + kind +
            '<div class="pgm-cart__qty">' +
              '<button type="button" data-act="dec" data-key="' + esc(item.key) + '" aria-label="' + tr('Diminuisci la quantità', 'Decrease quantity') + '">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-act="inc" data-key="' + esc(item.key) + '" aria-label="' + tr('Aumenta la quantità', 'Increase quantity') + '">+</button>' +
            '</div></div>' +
          '<div class="pgm-cart__side"><span class="pgm-cart__price">' + money(item.final_line_price, cart.currency) + '</span>' +
            '<button type="button" class="pgm-cart__rm" data-act="rm" data-key="' + esc(item.key) + '">' + tr('Rimuovi', 'Remove') + '</button></div>' +
        '</div>';
      }).join('');

      foot.innerHTML =
        '<div class="pgm-cart__total"><span>' + tr('Totale', 'Total') + '</span><span>' + money(cart.total_price, cart.currency) + '</span></div>' +
        '<p class="pgm-cart__note">' + esc(r.dataset.note) + '</p>' +
        '<form action="' + esc(r.dataset.cartUrl) + '" method="post"><button type="submit" name="checkout" class="pgm-btn pgm-btn--action pgm-btn--block">' + esc(r.dataset.checkoutLabel) + '</button></form>';
      foot.hidden = false;
    }

    function request(url, opts) {
      return fetch(url, opts).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var err = new Error(data.description || data.message || 'Errore');
            throw err;
          }
          return data;
        });
      });
    }

    function setBusy(on) {
      var r = root();
      if (!r) return;
      if (on) r.setAttribute('aria-busy', 'true'); else r.removeAttribute('aria-busy');
    }
    function setMessage(text) {
      var r = root();
      if (!r) return;
      var m = r.querySelector('[data-pgm-cart-msg]');
      m.textContent = text || '';
      m.hidden = !text;
    }
    function announce(text) {
      var r = root();
      if (r) r.querySelector('[data-pgm-cart-live]').textContent = text;
    }

    function update(cart) {
      lastCart = cart;
      setMessage('');
      render(cart);
      document.dispatchEvent(new CustomEvent('pgm:cart:updated', { detail: { count: cart.item_count } }));
      return cart;
    }
    function refresh() {
      return request(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(update);
    }

    function open() {
      var r = root();
      if (!r || r.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      r.classList.add('is-open');
      r.querySelector('[data-pgm-cart-drawer]').setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      r.querySelector('[data-pgm-cart-close]').focus();
    }
    function close() {
      var r = root();
      if (!r || !r.classList.contains('is-open')) return;
      r.classList.remove('is-open');
      r.querySelector('[data-pgm-cart-drawer]').setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function openWithRefresh() {
      var r = root();
      if (lastCart) {
        render(lastCart);
      } else {
        r.querySelector('[data-pgm-cart-body]').innerHTML = '<p class="pgm-cart__empty">' + tr('Carico il carrello…', 'Loading your cart…') + '</p>';
        r.querySelector('[data-pgm-cart-foot]').hidden = true;
      }
      open();
      refresh().catch(function () {
        window.location.href = r.dataset.cartUrl;
      });
    }

    function changeLine(key, qty, act) {
      setBusy(true);
      return request(shopRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(update).then(function () {
        var r = root();
        var again = r.querySelector('[data-act="' + act + '"][data-key="' + key + '"]');
        (again || r.querySelector('[data-pgm-cart-close]')).focus();
      }).catch(function () {
        setMessage(tr('Non è stato possibile aggiornare il carrello. Riprova.', 'Could not update the cart. Please try again.'));
      }).then(function () { setBusy(false); });
    }

    /* Aggiunta al carrello dai moduli dei prodotti (hero, griglia prodotti) */
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('form[data-pgm-add]') : null;
      if (!form || !root()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      request(shopRoot() + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function () { return refresh(); })
        .then(function () { openWithRefreshDone(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);

    function openWithRefreshDone() {
      open();
      announce(tr('Prodotto aggiunto al carrello.', 'Product added to cart.'));
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pgm-cart-open]');
      if (opener && root()) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        openWithRefresh();
        return;
      }
      if (e.target.closest('[data-pgm-cart-close]') || e.target.closest('[data-pgm-cart-overlay]')) {
        close();
        return;
      }
      var actBtn = e.target.closest('[data-pgm-cart] [data-act]');
      if (actBtn && lastCart) {
        var key = actBtn.dataset.key, act = actBtn.dataset.act;
        var line = lastCart.items.filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        var qty = line.quantity;
        if (act === 'inc') qty = Math.min(9, qty + 1);
        if (act === 'dec') qty = Math.max(1, qty - 1);
        if (act === 'rm') qty = 0;
        changeLine(key, qty, act);
      }
    });

    document.addEventListener('keydown', function (e) {
      var r = root();
      if (!r || !r.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(r.querySelectorAll('[data-pgm-cart-drawer] button, [data-pgm-cart-drawer] a[href]')).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    window.PGMCart = { open: openWithRefresh, close: close, refresh: refresh };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgm-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pgmHeaderReady) return;
    window.__pgmHeaderReady = true;

    function closeNav() {
      document.querySelectorAll('[data-pgm-nav].is-open').forEach(function (nav) {
        nav.classList.remove('is-open');
        var b = document.querySelector('[data-pgm-burger][aria-controls="' + nav.id + '"]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      var burger = e.target.closest('[data-pgm-burger]');
      if (burger) {
        var nav = document.getElementById(burger.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (e.target.closest('[data-pgm-nav] a')) closeNav();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    /* Aggiorna il contatore del carrello (chiamato dal carrello a scorrimento
       con: document.dispatchEvent(new CustomEvent('pgm:cart:updated', {detail:{count:n}})) ) */
    function updateCount(n) {
      document.querySelectorAll('[data-pgm-cart-count]').forEach(function (badge) {
        badge.textContent = n;
        badge.hidden = n === 0;
      });
      var en = (document.documentElement.lang || '').indexOf('en') === 0;
      var label = en
        ? (n === 0 ? 'Cart, empty' : 'Cart, ' + n + (n === 1 ? ' item' : ' items'))
        : (n === 0 ? 'Carrello, vuoto' : 'Carrello, ' + n + (n === 1 ? ' prodotto' : ' prodotti'));
      document.querySelectorAll('[data-pgm-cart-open]').forEach(function (a) {
        a.setAttribute('aria-label', label);
      });
    }
    document.addEventListener('pgm:cart:updated', function (e) {
      if (e.detail && typeof e.detail.count === 'number') updateCount(e.detail.count);
    });

    /* Se la pagina torna dalla cache del browser il contatore può essere vecchio */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { updateCount(c.item_count); })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgm-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Fa partire la lancetta dal secondo esatto in cui si carica la pagina */
    function setHands(root) {
      (root || document).querySelectorAll('[data-pgm-hand]').forEach(function (hand) {
        var d = new Date();
        hand.style.animationDelay = '-' + (d.getSeconds() + d.getMilliseconds() / 1000) + 's';
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setHands(); });
    } else {
      setHands();
    }
    document.addEventListener('shopify:section:load', function (e) { setHands(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgm-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pgmPdpReady) return;
    window.__pgmPdpReady = true;

    function money(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + cur;
      }
    }

    /* Cambio immagine dalle miniature */
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-pgm-thumb]');
      if (!thumb) return;
      var root = thumb.closest('[data-pgm-pdp]');
      var main = root && root.querySelector('.pgm-pdp__main');
      if (!main) return;
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt || '';
      root.querySelectorAll('[data-pgm-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
      });
    });

    /* Cambio variante: prezzo, disponibilità e codice da aggiungere al carrello */
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-pgm-option] input');
      if (!input) return;
      var root = input.closest('[data-pgm-pdp]');
      var dataEl = root.querySelector('[data-pgm-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-pgm-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
      var v = variants.filter(function (item) {
        return item.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      var btn = root.querySelector('[data-pgm-add-btn]');
      var idInput = root.querySelector('[data-pgm-variant-id]');
      var price = root.querySelector('[data-pgm-price]');
      var compare = root.querySelector('[data-pgm-compare]');

      if (!v) {
        btn.disabled = true;
        btn.textContent = btn.dataset.labelSoldout;
        return;
      }
      idInput.value = v.id;
      price.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compare.textContent = money(v.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgm-products"] && !Shopify.designMode) return;
  try {
    
  /* Coppia di copertine: al tocco o al clic la seconda esce da dietro alla prima.
     Al passaggio del mouse lo fa il CSS. Vale anche per l'hero. */
  (function () {
    if (window.__pgmPairReady) return;
    window.__pgmPairReady = true;
    document.addEventListener('click', function (e) {
      var pair = e.target.closest('[data-pgm-pair]');
      if (!pair) return;
      var open = pair.classList.toggle('is-open');
      pair.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
